import { render } from "./TypeOfProducts.vue?vue&type=template&id=4d83e57d"
import script from "./TypeOfProducts.vue?vue&type=script&lang=js"
export * from "./TypeOfProducts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__